let localProcess: any = {}

try {
  localProcess = process.env || {}
} catch (error) {
  console.error('Error getting process.env', error)
}

export const BASE_URL =
  localProcess && typeof localProcess.REACT_APP_HRM_ENDPOINT_URL === 'string'
    ? localProcess.REACT_APP_HRM_ENDPOINT_URL
    : // @ts-ignore
      import.meta.env?.VITE_HRM_ENDPOINT_URL
